import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Segment, Container, Header, Grid } from 'semantic-ui-react';
import { UniversalLink, PreviewImage } from '@plone/volto/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faXTwitter, faWhatsapp, faYoutube, faInstagram, faBluesky } from '@fortawesome/free-brands-svg-icons';
import { isEmpty, map } from 'lodash';


const View = (props) => {
    const { data, mode } = props;
    const isEditMode = mode === 'edit';

    const socialIcons = {
        facebook: faFacebookF,
        twitter: faXTwitter,
        youtube: faYoutube,
        whatsapp: faWhatsapp,
        instagram: faInstagram,
        bluesky: faBluesky,
    }

    const context = useSelector((state) => state.content.data);

    return (
        <div className={"minisiteInfo " + (!isEditMode ? 'full-width' : '')}>
            <Container>
                <Segment basic className='minisiteInfo__wrapper'>
                    <Grid>
                        <Grid.Row columns={12} centered>
                            <Grid.Column mobile={12} tablet={12} computer={6} widescreen={5} largeScreen={5}>
                                <Header as='h2' className='minisiteInfo__title'>
                                    {data?.title ? (
                                        <>{data.title}</>
                                    ) : (
                                        <>{context.title}</>
                                    )}
                                </Header>
                                {data?.description &&
                                    <p className="minisiteInfo__desc">{data?.description}</p>
                                }
                                <dl className="minisiteInfo__details">
                                    {data?.address &&
                                        <div className="minisiteInfo__item">
                                            <dt className="minisiteInfo__term"><FormattedMessage id="Address" defaultMessage="Address" />:</dt>
                                            <dd className="minisiteInfo__def">{data.address}</dd>
                                        </div>
                                    }
                                    {data?.phone &&
                                        <div className="minisiteInfo__item">
                                            <dt className="minisiteInfo__term"><FormattedMessage id="Phone" defaultMessage="Phone" />:</dt>
                                            <dd className="minisiteInfo__def"><UniversalLink href={'tel:+34' + data.phone.replace(/ /g, '')}>{data.phone}</UniversalLink></dd>
                                        </div>
                                    }
                                    {data?.email &&
                                        <div className="minisiteInfo__item">
                                            <dt className="minisiteInfo__term"><FormattedMessage id="Email" defaultMessage="Email" />:</dt>
                                            <dd className="minisiteInfo__def"><UniversalLink href={'mailto:' + data.email}>{data.email}</UniversalLink></dd>
                                        </div>
                                    }
                                    {data?.schedule &&
                                        <div className="minisiteInfo__item">
                                            <dt className="minisiteInfo__term"><FormattedMessage id="Schedule" defaultMessage="Schedule" />:</dt>
                                            <dd className="minisiteInfo__def">{data.schedule}</dd>
                                        </div>
                                    }
                                    
                                </dl>

                                {!isEmpty(data?.socialNetworks) > 0 && (
                                    <ul className="minisiteInfo__xxss list-unstyled">
                                        {map(data.socialNetworks, (item, key) => {
                                            const type = item.type ? item.type.toLowerCase() : null;
                                            if (!type || !socialIcons[type]) {
                                                return null;
                                            }
                                            const icon = socialIcons[type];

                                            return (
                                                <li key={key}>
                                                    <UniversalLink className={`minisiteInfo__xxss__link minisiteInfo__xxss__link--${type}`} href={item.url}>
                                                        <FontAwesomeIcon icon={icon} className="minisiteInfo__xxss__icon" />
                                                        <span className="visually-hidden">{item.type}</span>
                                                    </UniversalLink>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}

                            </Grid.Column>
                            <Grid.Column mobile={12} tablet={8} computer={6} widescreen={5} largeScreen={5}>
                                
                                {data?.image &&
                                <div className="minisiteInfo__img">
                                    <PreviewImage
                                        item={data?.image?.[0]}
                                    />
                                </div>
                                }

                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </Segment>
            </Container>
        </div>
    )
}

export default View;